@if (visible()) {
<div class="floating-panel" [@zoomInOut]="true">
  @if (!icon()) {
  <av-spinner size="lg"></av-spinner>
  } @if (!!icon()) {
  <av-icon mode="light" [class]="cssClass()" [name]="icon()"></av-icon>
  } @if (!!message()) {
  <div class="floating-panel-message" aria-hidden="true">
    {{ message() | translate }}
  </div>
  }
</div>
} @if (backdropVisible()) {
<div class="floating-backdrop" [@fadeOut]="true"></div>
}
